import { Image, List, Icon } from 'semantic-ui-react';
import "../css/renderMusic.scss"

const renderMusic = (data) => {
    return data.map((elem) => {
        console.log(`elem.links`, elem.links);
        return (
            <List.Item key={elem.name}>
                <Image size='medium' src={elem.cover} />
                <List.Content>
                    <List.Header>{elem.name}</List.Header>
                    Release Year :{elem.releaseYear} <br />
                    {elem.links.length > 0 ?
                        elem.links.map(song => {
                            return <a key={song.link} href={song.link}><Icon size="large" name={song.type}>  </Icon></a>
                        })
                        : ""
                    }
                </List.Content>

            </List.Item>
        )
    })
}

export default renderMusic;